export const Exceptions = [
  "phase_plant_backdrop",
  "phase_plant_backdrop_alpha",
  "multipass_backdrop",
  "multipass_backdrop_alpha",
  "snap_heap_backdrop",
  "snap_heap_backdrop_alpha"
]